'use client';

import type { ReactNode } from 'react';

import { ExternLogo } from '@extern/ui/logos/extern-logo';
import { Text } from '@extern/ui/text';

const DEFAULT_LAYOUT_TEXT = (
  <>
    Start Your Career <br />
    Journey with Extern
  </>
);

interface LayoutProps {
  children: ReactNode;
  text?: ReactNode;
}

export function CenteredAuthLayout({ children, text = DEFAULT_LAYOUT_TEXT }: LayoutProps) {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-role-surface">
      <div className="flex w-full max-w-full flex-col items-center gap-8 px-6 sm:w-[358px] sm:px-0">
        <div className="flex size-[72px] items-center justify-center rounded-full bg-white">
          <ExternLogo height={32} width={32} />
        </div>

        <Text className="text-center" title="lg">
          {text}
        </Text>

        {children}
      </div>
    </div>
  );
}
